import { useMemo, useState } from 'react'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const MENU_ITEMS = ['1. Editar', '2. Deletar']

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_ESTOQUE: 'Carregando estoques',
  GET_POSICOES: 'Carregando posições',
  GET_MOTIVOS: 'Carregando motivos',
  GET_HISTORICO: 'Carregando histórico',
  GET_PALLETS: 'Carregando pallets',
  DESBLOQUEAR_POS: 'Desbloqueando posições',
  BLOQUEAR_POS: 'Bloqueando posições',
  SUCCESS: 'Posição criada com sucesso',
}

const INITIAL_STATE = {
  posicoes: [],
  estoque: [],
  selectedEstoque: null,
  selectedPosicaoEstoque: null,
  pallets: [],
  selectedPallet: null,
  showModalPallet: false,
  qtePosicoes: 0,
  qtePosicoesOcupadas: 0,
  qtePosicoesBloqueadas: 0,
  taxaOcupacao: 0,
  posicoesEmExpedicao: 0,
  posicoesEmInventario: 0,
  selecionarTodos: false,
  originalPosicoes: [],
  posicoesToUpdate: [],
  periodo: getPeriodoMesAtual(),
  selectedPosicao: {},
  modalVisible: false,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  successMessage: null,
  activeIndex: 0,
  posicaoHistorico: [],
  globalFilter: '',
  globalFilterBloqueio: '',
  globalFilterPallet: '',
}

export default function useGerenciamentoPosicoesEstoque() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          successMessage: null,
          errorMessage: null,
        }))
      },

      bloquearPosicoesEstoque(
        selectedTp,
        selectedEstoque,
        selectedPosicoes,
        selectedMotivo,
        justificativaBloqueio,
      ) {
        if (!selectedPosicoes.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos uma posição para bloquear',
          }))
        else if (!selectedMotivo)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione um motivo para o bloqueio',
          }))
        else {
          EstoqueHttp.blockPosicoesEstoque(
            selectedTp,
            selectedPosicoes.map(p => p.id),
            selectedMotivo.id,
            justificativaBloqueio,
            selectedEstoque.id,
          )
            .then(res =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.GET_POSICOES,
                successMessage: 'Bloqueio efetuado com sucesso',
              })),
            )
            .catch(err => {
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
            })
        }
      },

      desbloquearPosicoesEstoque(selectedTp, selectedPosicoes) {
        if (!selectedPosicoes.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos uma posição para desbloquear',
          }))
        else {
          EstoqueHttp.unblockPosicoesEstoque(
            selectedTp,
            selectedPosicoes.map(p => p.id),
          )
            .then(res =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.GET_POSICOES,
                successMessage: 'Desbloqueio efetuado com sucesso',
              })),
            )
            .catch(err => {
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
            })
        }
      },

      historicoPosicaoEstoque(selectedTp, selectedPosicao) {
        EstoqueHttp.historicoBlockPosicoesEstoque(selectedTp, selectedPosicao.id)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              posicaoHistorico: res,
            })),
          )
          .catch(err => {
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
      },

      getPosicoesEstoque(selectedTp, estoqueId) {
        EstoqueHttp.getPosicoesEstoques(selectedTp, estoqueId)
          .then(res => {
            const qtePosicoes = res.length
            const qtePosicoesOcupadas = res.reduce((total, item) => {
              if (item.caixas) total++
              return total
            }, 0)

            const qtePosicoesBloqueadas = res.filter(r => r.motivo_bloqueio_id).length

            const taxaOcupacao =
              qtePosicoes === 0
                ? '0%'
                : +((qtePosicoesOcupadas / qtePosicoes) * 100).toFixed(2) + '%'

            const posicoesEmExpedicao = res.filter(r => r.expedicaoName).length
            const posicoesEmInventario = res.filter(r => r.inventarioName).length

            setState(prevState => ({
              ...prevState,
              posicoes: res.map(res => ({ selected: false, ...res })),
              qtePosicoes: qtePosicoes,
              qtePosicoesOcupadas: qtePosicoesOcupadas,
              taxaOcupacao: taxaOcupacao,
              qtePosicoesBloqueadas: qtePosicoesBloqueadas,
              originalPosicoes: res,
              posicoesEmExpedicao: posicoesEmExpedicao,
              posicoesEmInventario: posicoesEmInventario,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err => {
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
      },

      getEstoque(selectedTp) {
        EstoqueHttp.getEstoques(selectedTp)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              estoques: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getMotivosBloqueioPosicao(selectedTp) {
        EstoqueHttp.getMotivosBloqueioPosicaoEstoque(selectedTp)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              motivos: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getPalletsStatus(posicaoId) {
        EstoqueHttp.getPalletsStatus(posicaoId)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              pallets: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err => {
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
      },

      //Events
      onInit(selectedTp) {
        if (selectedTp) {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_ESTOQUE }))
        }
      },

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value

          if (name === 'activeIndex') {
            prevState.globalFilter = ''
            prevState.globalFilterBloqueio = ''
            prevState.globalFilterPallet = ''
            if (value !== 2) {
              prevState.selectedPosicaoEstoque = null
              prevState.pallets = []
            }
          }

          if (name === 'selectedEstoque') {
            prevState.loadingMessage = LOAD_MESSAGE.GET_POSICOES
            prevState.selectedPosicaoEstoque = null
            prevState.pallets = []
          } else if (name === 'selectedPosicaoEstoque' && value && prevState.activeIndex === 2) {
            prevState.loadingMessage = LOAD_MESSAGE.GET_PALLETS
          } else if (name === 'activeIndex' && value === 1) {
            prevState.loadingMessage = LOAD_MESSAGE.GET_MOTIVOS
          } else if (name === 'activeIndex' && value === 2 && prevState.selectedEstoque) {
            prevState.loadingMessage = LOAD_MESSAGE.GET_POSICOES
          } else if (name === 'selectedPosicao') {
            prevState.modalVisible = true
          }
          return { ...prevState }
        })
      },

      onSelecionarTodosChange() {
        setState(prev => {
          prev.selecionarTodos = !prev.selecionarTodos
          prev.posicoes.forEach(a => (a.selected = prev.selecionarTodos))
          return { ...prev }
        })
      },

      onClickBloquear() {
        setState(prev => ({ ...prev, loadingMessage: LOAD_MESSAGE.BLOQUEAR_POS }))
      },

      onClickDesbloquear() {
        setState(prev => ({ ...prev, loadingMessage: LOAD_MESSAGE.DESBLOQUEAR_POS }))
      },

      onItemCheckboxClick(item) {
        const { id } = item
        setState(prev => {
          const index = prev.posicoes.findIndex(a => a.id === id)
          if (index !== -1) {
            prev.posicoes[index].selected = prev.posicoes[index].selected !== true
          }
          return { ...prev }
        })
      },

      async onBtnExportarExcel() {
        const colunasPosicoes = [['endereço', 'sequencia', 'capacidade']]
        gerarArquivoExcel('Posições', colunasPosicoes, `PosicoesDeEstoque.xlsx`)
      },

      onMenuItemClicked(posicao, selectedTp) {
        setState(prevState => ({
          ...prevState,
          showModalHistorico: true,
          selectedPosicao: posicao,
          loadingMessage: LOAD_MESSAGE.GET_HISTORICO,
        }))
      },

      onPalletRowClick(pallet) {
        setState(prevState => ({
          ...prevState,
          selectedPallet: pallet,
          showModalPallet: true,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
